"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadUserProfile = loadUserProfile;

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _API = require("../../API");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function loadUserProfile() {
    return function (dispatch, getState) {
        return _API.client.requestReduxType(_API.API.getUserProfile(), [C.USER_PROFILE, C.USER_PROFILE_SUCCESS, C.USER_PROFILE_FAILED], dispatch);
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/user/actions.ts
 ** module id = 645
 ** module chunks = 0
 **/